<!-- Zweck: Zeigt Suche, Treffer und Aktionen zur Auswahl eines Impersonation-Ziels. -->
<h2 mat-dialog-title>Read-only-Impersonation starten</h2>
<mat-dialog-content class="target-picker-content">
  <mat-form-field appearance="outline" class="search-field">
    <mat-label>Name, E-Mail oder Kundennummer suchen</mat-label>
    <input matInput #searchInput [value]="search" (input)="onSearch(searchInput.value)" autocomplete="off">
  </mat-form-field>

  <div class="target-table-wrapper" role="region" aria-label="Suchergebnisse">
    @if (loading) {
      <p>Benutzer werden geladen …</p>
    } @else if (error) {
      <p class="error-message">{{error}}</p>
    } @else if (!targets.length) {
      <p>Keine passenden Benutzer gefunden.</p>
    } @else {
      <mat-table [dataSource]="targets" class="mat-table transpose-sm">
        <ng-container matColumnDef="usertype">
          <mat-header-cell *matHeaderCellDef>Benutzerart</mat-header-cell>
          <mat-cell *matCellDef="let target" data-label="Benutzerart">
            @if (target.vertreter) { <span>Vertreter</span> }
            @if (target.kunde) { <span>Kunde</span> }
            @if (!target.vertreter && !target.kunde) { <span>–</span> }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="customerobject">
          <mat-header-cell *matHeaderCellDef>Kunde/Vertreter</mat-header-cell>
          <mat-cell *matCellDef="let target" data-label="Kunde/Vertreter">
            @if (target.vertreter) {
              <div>{{target.vertreter.VertreterNr}} - {{target.vertreter.Vorname}} {{target.vertreter.Nachname}}</div>
            }
            @if (target.kunde) {
              <div>{{target.kunde.KundeNr}} - {{target.kunde.Vorname}} {{target.kunde.Nachname}}</div>
            }
            @if (!target.vertreter && !target.kunde) { <span>–</span> }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fullname">
          <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
          <mat-cell *matCellDef="let target" data-label="Name">{{target.benutzerandruckname}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="email">
          <mat-header-cell *matHeaderCellDef>E-Mail</mat-header-cell>
          <mat-cell *matCellDef="let target" data-label="E-Mail">{{target.email}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="lastseen">
          <mat-header-cell *matHeaderCellDef>Zuletzt gesehen</mat-header-cell>
          <mat-cell *matCellDef="let target" data-label="Zuletzt gesehen">{{target.last_seen || '–'}}</mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns" class="target-row" tabindex="0"
                 [attr.aria-label]="'Read-only-Impersonation für ' + row.benutzerandruckname + ' starten'"
                 (click)="selectTarget(row)"
                 (keydown.enter)="selectTarget(row)"
                 (keydown.space)="selectTarget(row); $event.preventDefault()"></mat-row>
      </mat-table>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="previousPage()" [disabled]="page === 1 || loading">Zurück</button>
  <span class="page-number">Seite {{page}}</span>
  <button mat-button (click)="nextPage()" [disabled]="targets.length < 25 || loading">Weiter</button>
  <button mat-button mat-dialog-close>Abbrechen</button>
</mat-dialog-actions>
